<script>
import ThreeMixin from "./Three.vue";
import { Color, OrthographicCamera } from "three";
import FunctionSurface from "./FunctionSurface.js";

const surfaces = [
  import("../assets/shooting_eigenfunctions/f.json"),
  import("../assets/shooting_eigenfunctions/f_0.json"),
  import("../assets/shooting_eigenfunctions/f_1.json"),
  import("../assets/shooting_eigenfunctions/f_2.json"),
  import("../assets/shooting_eigenfunctions/f_3.json"),
];

export default {
  props: {
    index: { default: 0, type: Number },
    progress: { default: 1, type: Number },
  },
  mixins: [ThreeMixin],
  created() {
    this.renderer.setClearColor(new Color("white"));

    this.camera = new OrthographicCamera(-1, 1, -1, 1, -100, 100);
    this.camera.position.set(0, 1, 0);
    this.camera.lookAt(0, 0, 0);
    this.aspect = 1;

    this.addSurface();

    this.$on("resizeCanvas", (width, height) => {
      this.aspect = width / height;
      this.resizeCanvasCallback();
    });
  },
  watch: {
    progress() {
      if (this.functionSurface) {
        this.functionSurface.progress = this.progress;
        this.renderFrame();
      }
    },
  },
  mounted() {
    this.renderFrame();
  },
  destroyed() {
    if (this.functionSurface) this.functionSurface.dispose();
  },
  methods: {
    renderFrame() {
      if (this.functionSurface) {
        this.render();
      }
    },
    resizeCanvasCallback() {
      if (!this.functionSurface) return;
      const [xmin, xmax] = this.functionSurface.xBounds;
      const [ymin, ymax] = this.functionSurface.yBounds;

      const x = (xmin + xmax) / 2;
      const y = (ymin + ymax) / 2;

      let w = xmax - xmin;
      let h = ymax - ymin;
      if (this.aspect < 1) h /= this.aspect;
      else w *= this.aspect;

      this.camera.left = x - w / 2;
      this.camera.right = x + w / 2;
      this.camera.bottom = y - h / 2;
      this.camera.top = y + h / 2;
      this.camera.updateProjectionMatrix();
      this.renderFrame();
    },
    addSurface() {
      surfaces[this.index].then((data) => {
        if (this.functionSurface) this.scene.remove(this.functionSurface);
        this.functionSurface = new FunctionSurface(data);
        this.functionSurface.progress = this.progress;
        if (this.index == 4)
          this.functionSurface.material.uniforms.heightScale.value *= 50;
        this.scene.add(this.functionSurface);
        this.resizeCanvasCallback();
      });
    },
  },
};
</script>